import { Stack, Step, StepLabel, Stepper, styled } from '@mui/material';
import React, { FC } from 'react';
import { TransportType } from 'src/types/transport';
import { StepIconProps } from '@mui/material/StepIcon';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import translate from '@translate';
import Typography from 'src/components/Typography';
import { DateType } from 'src/types/date';
import moment from 'moment';
import { colors } from 'src/themes/default';
import { StackProps } from '@mui/system';
import { DeliveredIcon, InprocessIcon, OnthewayIcon, PrereceivedIcon } from 'src/components/SkladonIcon/OldIcons';

type TransportProgressStepKey = 'created' | 'shippingCreated' | 'onTheWay' | 'atPickupPoint' | 'delivered';

const progressSteps: {
    label: string;
    icon: React.ReactElement;
    timeKey: keyof TransportType;
    key: TransportProgressStepKey;
}[] = [
    { label: translate('transportDetail.status.created'), icon: <PrereceivedIcon />, timeKey: 'CREATED_AT', key: 'created' },
    {
        label: translate('transportDetail.status.shippingCreated'),
        icon: <InprocessIcon />,
        timeKey: 'SHIPPING_CREATED_AT',
        key: 'shippingCreated',
    },
    { label: translate('transportDetail.status.onTheWay'), icon: <OnthewayIcon />, timeKey: 'ON_THE_WAY_AT', key: 'onTheWay' },
    {
        label: translate('transportDetail.status.atPickupPoint'),
        icon: <OnthewayIcon />,
        timeKey: 'AT_PICKUP_POINT_AT',
        key: 'atPickupPoint',
    },
    { label: translate('transportDetail.status.delivered'), icon: <DeliveredIcon />, timeKey: 'DELIVERED_AT', key: 'delivered' },
];

const formatTime = (data: DateType) => {
    if (!data) {
        return ' ';
    }
    return moment(data).format('lll');
};

const StyledStack = styled(Stack)<StackProps>(({ theme }) => ({
    width: '100%',
    margin: '20px auto',
    maxWidth: '500px',
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    zIndex: 1,
    marginTop: '10px',
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 28,

        '&  .MuiStepConnector-lineHorizontal': {
            transportColor: colors.text_T3,
        },
    },
}));

export interface ProgressPropsType {
    data: TransportType | null;
}

const Progress: FC<ProgressPropsType> = (props) => {
    if (!props.data) {
        return null;
    }

    const visibleSteps = props.data.AT_PICKUP_POINT_AT
        ? progressSteps
        : progressSteps.filter((step) => step.key !== 'atPickupPoint');

    const StepIcon = (iconProps: StepIconProps) => {
        const { active, completed, className } = iconProps;
        const step = visibleSteps[Number(iconProps.icon) - 1];

        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {step?.icon}
            </ColorlibStepIconRoot>
        );
    };

    return (
        <StyledStack spacing={4}>
            <Stepper alternativeLabel activeStep={1} connector={<ColorlibConnector />}>
                {visibleSteps.map((step) => (
                    <Step key={step.label}>
                        <StepLabel StepIconComponent={StepIcon}>
                            <>
                                <Typography variant="h3">{step.label}</Typography>
                                <Typography variant="body2" gutterBottom>
                                    {formatTime(props.data && (props.data[step.timeKey] as DateType))}
                                </Typography>
                            </>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </StyledStack>
    );
};

export default Progress;
